import {captureException} from '@sentry/browser';
import axios from 'axios';
import {showNotification} from 'platform/components';

import {useState} from 'react';

import {i18n} from '@dms/i18n';

import {Nullish} from 'shared/web';

import {ServiceCaseInvoiceType} from '../types/ServiceCaseInvoiceType';
import {downloadBlobFile} from '../utils/downloadBlobFile';
import {printPDF} from '../utils/printPDF';

export const useDownloadServiceCaseInvoiceDocument = (shouldPrintTheDocument: boolean) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const downloadInvoice = (
    invoiceId: string,
    invoiceNumber: string | Nullish,
    type: ServiceCaseInvoiceType = 'invoice'
  ) => {
    setIsLoading(true);
    setIsError(false);

    axios
      .post(
        `/v1/workshop/${type}/${invoiceId}/export`,
        {},
        {
          responseType: 'arraybuffer',
          headers: {
            Accept: 'application/pdf',
          },
        }
      )
      .then((response) => {
        if (shouldPrintTheDocument) {
          printPDF(new Blob([response.data], {type: 'application/pdf'}));
        } else {
          downloadBlobFile(
            response.data,
            i18n.t('entity.invoice.labels.invoiceFile', {
              invoiceNumber,
            })
          );
        }
      })
      .catch((e) => {
        console.error(e);
        setIsError(true);
        captureException(e);
        showNotification.error();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return [downloadInvoice, {isLoading, isError}] as const;
};
